import React, { useEffect } from 'react'
import { useIntl } from 'react-intl'
import {
  PanelToggle,
  Flex,
  Text,
  InputNumber,
  FlexItem,
  HelpIcon,
  Tooltip,
  Panel,
  Title,
  SpacingVertical,
  Link
} from 'mailup-web-components'
import { useRecoilCallback, useRecoilValue, useSetRecoilState } from 'recoil'

import {
  STORE_KEY_ACCOUNT,
  STORE_KEY_LIST,
  evalCondition,
  notifyParent,
  storeGet
} from 'mailup-react-helpers'
import {
  fasciaDiNonDisturboInvalidSelector,
  fasciaDiNonDisturboState
} from 'Pages/EmailSendingQueueManage/recoil/state/page'
import { initFasciaDiNonDisturboCallback } from 'Pages/EmailSendingQueueManage/recoil/callbacks/callbacks'

const BoxFasciaDiNonDisturbo = () => {
  const intl = useIntl()

  const { enable, Start, End } = useRecoilValue(fasciaDiNonDisturboState)
  const setFasciaDiNonDisturboState = useSetRecoilState(
    fasciaDiNonDisturboState
  )
  const fasciaDiNonDisturboInvalid = useRecoilValue(
    fasciaDiNonDisturboInvalidSelector
  )
  const initFasciaDiNonDisturbo = useRecoilCallback(
    initFasciaDiNonDisturboCallback,
    []
  )
  const { TimeZoneCode } = storeGet(STORE_KEY_LIST)
  const addOnEnabled = evalCondition('co:DONOTDISTURBMODE')
  const account = storeGet(STORE_KEY_ACCOUNT)
  const fasciaDiNonDisturboEnabled = account.IdOffer !== 1
  const isStarterOrFrequenza = account.IdOffer === 3 || account.IdOffer === 2
  const showMshop = evalCondition(
    'uo:GEST AND NOT c:IsRetailer AND NOT c:IsDeveloper AND NOT co:TURNOFFMSHOP'
  )

  useEffect(() => {
    initFasciaDiNonDisturbo()
  }, [])

  const handleOnChangeToggle = () => {
    setFasciaDiNonDisturboState(prev => ({
      ...prev,
      isDirty: true,
      enable: !prev.enable
    }))
  }

  const handleStartNDHour = value => {
    if (value >= 0) {
      setFasciaDiNonDisturboState(prev => ({
        ...prev,
        isDirty: true,
        Start: {
          minutes: prev.Start.minutes,
          hours: value
        }
      }))
    }
  }
  const handleStartNDMinute = value => {
    if (value >= 0) {
      setFasciaDiNonDisturboState(prev => ({
        ...prev,
        isDirty: true,
        Start: {
          hours: prev.Start.hours,
          minutes: value
        }
      }))
    }
  }

  const handleEndNDHour = value => {
    if (value >= 0) {
      setFasciaDiNonDisturboState(prev => ({
        ...prev,
        isDirty: true,
        End: {
          minutes: prev.End.minutes,
          hours: value
        }
      }))
    }
  }

  const handleEndNDMinute = value => {
    if (value >= 0) {
      setFasciaDiNonDisturboState(prev => ({
        ...prev,
        isDirty: true,
        End: {
          hours: prev.End.hours,
          minutes: value
        }
      }))
    }
  }

  const goToDocumentation = () => {
    switch (account.Language.toLowerCase()) {
      case 'it':
        window
          .open(
            'https://helpmailup.atlassian.net/wiki/spaces/MM/pages/37319880/Scegli+destinatari#Sceglidestinatari-Fasciadinondisturbo',
            '_blank',
            'noopener,noreferrer'
          )

        break

      case 'es':
        window
          .open(
            'https://helpmailup.atlassian.net/wiki/spaces/MMES/pages/37041856/Env+a#Env%C3%ADa-HorariodeNoMolestar',
            '_blank',
            'noopener,noreferrer'
          )
        break
      default:
        window
          .open(
            'https://helpmailup.atlassian.net/wiki/spaces/MUG/pages/36868798/Sending#Sending-DonotDisturbMode',
            '_blank',
            'noopener,noreferrer'
          )
        break
    }
  }

  const goToMshop = () => {
    notifyParent('redirectMainFrame', [
      'mshop_redirector.aspx?t=mshopproddet&cp=FDND'
    ])
  }

  return (
    <>
      <Tooltip />
      {!fasciaDiNonDisturboEnabled && (
        <Panel>
          <Title variant='M'>
            {intl.formatMessage({
              id: 'Load.QueueStatus.DndTitle'
            })}
            <HelpIcon
              text={intl.formatMessage({
                id: 'Load.QueueStatus.DndMonetizeNotAvailableTooltip'
              })}
            />
          </Title>
          <SpacingVertical variant='16' />
          <Text>
            {intl.formatMessage(
              {
                id: 'Load.QueueStatus.DndMonetizeNotAvailableBody'
              },
              {
                link: chunks => (
                  <Link variant='default' onClick={goToDocumentation}>
                    {chunks}
                  </Link>
                )
              }
            )}
          </Text>
        </Panel>
      )}
      {fasciaDiNonDisturboEnabled && (
        <>
          {(isStarterOrFrequenza || account.IsOfferLight) && !addOnEnabled ? (
            <Panel>
              <Title variant='M'>
                {intl.formatMessage({
                  id: 'Load.QueueStatus.DndTitle'
                })}
                <HelpIcon
                  text={intl.formatMessage({
                    id: 'Load.QueueStatus.DndStarterTooltip'
                  })}
                />
              </Title>
              <SpacingVertical variant='16' />
              {showMshop && (
                <Text>
                  {intl.formatMessage(
                    {
                      id: 'Load.QueueStatus.DndStarterMshopBody'
                    },
                    {
                      link1: chunks => (
                        <Link
                          variant='highlight'
                          onClick={goToMshop}
                          data-mu-test='fndm-queueManage-linkBuy'
                        >
                          {chunks}
                        </Link>
                      ),
                      link2: chunks => (
                        <Link variant='default' onClick={goToDocumentation}>
                          {chunks}
                        </Link>
                      )
                    }
                  )}
                </Text>
              )}
              {!showMshop && (
                <Text>
                  {intl.formatMessage(
                    {
                      id: 'Load.QueueStatus.DndStarterNoMshopBody'
                    },
                    {
                      link: chunks => (
                        <Link variant='default' onClick={goToDocumentation}>
                          {chunks}
                        </Link>
                      )
                    }
                  )}
                </Text>
              )}
            </Panel>
          ) : (
            <PanelToggle
              onChange={handleOnChangeToggle}
              checked={enable}
              title={intl.formatMessage({
                id: 'Load.QueueStatus.DndTitle'
              })}
              data-mu-test='PanelToggle_FasciaDiNonDisturbo'
            >
              <>
                <Text htmlElement='span'>
                  {intl.formatMessage({ id: 'Load.QueueStatus.DndBody' })}
                </Text>
                <Flex
                  alignItems='flex-start'
                  columnGap='8px'
                  margin='16px 0 0 0'
                >
                  <FlexItem margin='8px 0 0 0'>
                    <Text htmlElement='span'>
                      {intl.formatMessage({
                        id: 'Load.QueueStatus.DndTimeFrom'
                      })}
                    </Text>
                  </FlexItem>
                  <Flex display='block' width='70px'>
                    <InputNumber
                      value={Start.hours}
                      onChange={handleStartNDHour}
                      min={0}
                      max={23}
                      precision={0}
                      variant={fasciaDiNonDisturboInvalid ? 'danger' : ''}
                    />
                  </Flex>
                  <FlexItem margin='8px 0 0 0'>
                    <Text>:</Text>
                  </FlexItem>
                  <Flex display='block' width='70px'>
                    <InputNumber
                      value={Start.minutes}
                      onChange={handleStartNDMinute}
                      min={0}
                      max={59}
                      step={5}
                      precision={0}
                      variant={fasciaDiNonDisturboInvalid ? 'danger' : ''}
                    />
                  </Flex>
                  <FlexItem margin='8px 0 0 0'>
                    <Text htmlElement='span'>
                      {intl.formatMessage({ id: 'Load.QueueStatus.DndTimeTo' })}
                    </Text>
                  </FlexItem>

                  <Flex display='block' width='70px'>
                    <InputNumber
                      value={End.hours}
                      onChange={handleEndNDHour}
                      min={0}
                      max={23}
                      precision={0}
                      variant={fasciaDiNonDisturboInvalid ? 'danger' : ''}
                    />
                  </Flex>
                  <FlexItem margin='8px 0 0 0'>
                    <Text>:</Text>
                  </FlexItem>
                  <Flex display='block' width='70px'>
                    <InputNumber
                      value={End.minutes}
                      onChange={handleEndNDMinute}
                      min={0}
                      max={59}
                      step={5}
                      precision={0}
                      variant={fasciaDiNonDisturboInvalid ? 'danger' : ''}
                    />
                  </Flex>
                  <FlexItem margin='8px 0 0 0'>
                    <Text variant='italic'>
                      {intl.formatMessage({
                        id: 'Load.QueueStatus.DndTimeZone'
                      }) +
                        ' ' +
                        TimeZoneCode.split('.')[0]}
                    </Text>
                  </FlexItem>
                  <FlexItem margin='8px 0 0 0'>
                    <HelpIcon
                      text={intl.formatMessage({
                        id: 'Load.QueueStatus.DndTooltip'
                      })}
                    />
                  </FlexItem>
                </Flex>
                {fasciaDiNonDisturboInvalid && (
                  <label className='input_is-required_text'>
                    {intl.formatMessage(
                      {
                        id: 'Load.QueueStatus.DndInvalid'
                      },
                      {
                        linebreak: <br />
                      }
                    )}
                  </label>
                )}
              </>
            </PanelToggle>
          )}
        </>
      )}
    </>
  )
}

export default BoxFasciaDiNonDisturbo
